/* __next_internal_client_entry_do_not_use__ InsightCardContext,InsightCardContextProvider auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { EventOrigin, InsightCardElement } from "@faire/retailer-visitor-shared/features/InsightsFeed/events";
import { trackMyBrandsInsightsCardClick } from "@faire/web-api--source/events/myBrands/click/insightsCard";
import { trackMyBrandsInsightsCardView } from "@faire/web-api--source/events/myBrands/view/insightsCard";
import React, { useState } from "react";
export var InsightCardContext = /*#__PURE__*/ React.createContext({});
export var InsightCardContextProvider = function(props) {
    var _useState = _sliced_to_array(useState([]), 2), mutedBrands = _useState[0], setMutedBrands = _useState[1];
    var _props_origin;
    var containerOrigin = (_props_origin = props.origin) !== null && _props_origin !== void 0 ? _props_origin : EventOrigin.Unknown;
    var onChangeMute = function(brandToken) {
        if (!brandToken) {
            return;
        }
        setMutedBrands(function(prev) {
            return prev.includes(brandToken) ? prev.filter(function(token) {
                return token !== brandToken;
            }) : prev.concat(brandToken);
        });
    };
    var handleCardVisible = function(token) {
        trackMyBrandsInsightsCardView(containerOrigin, token);
    };
    var handleCardClick = function(type) {
        return function(token, ctaLink) {
            var _props_onCardClick;
            trackMyBrandsInsightsCardClick(containerOrigin, type, ctaLink !== null && ctaLink !== void 0 ? ctaLink : token);
            (_props_onCardClick = props.onCardClick) === null || _props_onCardClick === void 0 ? void 0 : _props_onCardClick.call(props, token);
        };
    };
    return /*#__PURE__*/ _jsx(InsightCardContext.Provider, {
        value: {
            containerOrigin: containerOrigin,
            mutedBrands: mutedBrands,
            onChangeMute: onChangeMute,
            onVisible: handleCardVisible,
            onBrandClick: handleCardClick(InsightCardElement.Brand),
            onProductClick: handleCardClick(InsightCardElement.Product),
            onOverlayClick: handleCardClick(InsightCardElement.Overlay)
        },
        children: props.children
    });
};
